import { API_BASE_URL } from 'config/api';

export const TINY_API_KEY = 'm7nnw6qfwmmekiggsidg8d6tazcjb9zvx8edfrkr5ybyioke';

export { API_BASE_URL };

export default {
    API_BASE_URL
};
